import axios from 'axios'
import store from '../store'
import Qs from 'qs'

// 英文站没有找到对应的env配置文件，因此写死在这里
// const FTA_BASE_URL = process.env.NODE_ENV === 'development' ? "/fta" : "http://172.26.11.91:30002/xhsl/"
// const FTA_BASE_URLS = process.env.NODE_ENV === 'development' ? "/ftas" : "http://172.26.11.91:30000/xhsl/"


// 创建axios实例
const http = axios.create({
    // api地址
    // baseURL: process.env.FTA_BASE_URL,
    // baseURL: FTA_BASE_URL,
    // 请求超时时间
    timeout: 6000 * 10,
    // 跨域携带cookie
    withCredentials: true
})

// 请求拦截
http.interceptors.request.use(config => {
    // if (config.method === 'post') {
    //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    //   config.data = Qs.stringify(config.data)
    // }
    // console.log(config)

    const ftaToken = store.state.Fta.ftaToken
    if (ftaToken && ftaToken.length) {
        config.headers['authorization-token'] = ftaToken
    }

    if (config.url.indexOf('downloadFile') != -1 || config.url.indexOf('download') !== -1) {
        config.responseType = 'blob'
    }
    if (config.method.toLowerCase() === 'post') {
        // console.log(config.data)
        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data; charset=UTF-8'
            config.responseType = 'blob'
        }
    }

    config.headers['Authorization'] = null
    config.headers['reqLanguage'] = 'en'
    config.headers['API-TOKEN'] = '6CF7F86306F30DB8F5231F22C489D730'
    config.headers['Accept-Encoding', 'gzip,deflate']
    // config.headers['Access-Control-Allow-Origin', 'http://localhost:8080'];

    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截
http.interceptors.response.use(response => {
    if (['application/json;charset=UTF-8'].includes(response.headers['content-type']) == false) {
        return response
    }
    // console.log(response.headers['content-type'])
    // if (response.headers['content-type'].indexOf('zip') > 0) {
    //   return response
    // }

    // 获取状态码
    const code = response.data.resCode

    switch (code) {
    // 请求成功
    case 0:
      return response.data
    // 逻辑错误
    case 1:
      break
    case 401:
      /* token失效  跳转到登陆*/
      let str = location.href
      let num = str.indexOf('#')
      str = str.substr(num + 1)
      console.log('3333');
      window.location.href = 'https://en.imsilkroad.com/login#' + str
    //   route.replace('/login')
      break
    case 403:
      /* 没权限 */
      route.push({
        name: 'noPermission'
      })
    }
}, error => {
    if (error.response) {
         console.log(error.response)
      } else { 
         // 如果没有返回体，退出登录
         let str = location.href
         let num = str.indexOf('#')
         str = str.substr(num + 1)
        console.log('4444');
         window.location.href = 'https://en.imsilkroad.com/login#' + str
      }
    // 500 401
    return Promise.reject(error)
})

export default function request(method, url, data = {}) {
    data = method === 'get' ? {params: data} : data
    return new Promise((resolve, reject) => {
        http[method](url, data).then(response => {
            resolve(response)
        }, error => {
            reject(error)
        }).catch(error => {
            reject(error)
        })
    }).catch(error => {
        console.log(error)
    })
}
